
import { defineComponent, nextTick, onMounted, ref, watch } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
const customColorMethod = (percentage: number) => {
  if (percentage < 60) {
    return "#f56c6c";
  }
  return "#67c23a";
};
const dialogVisible = ref(false);
import jQuery from "jquery";
const $ = jQuery;
const video = ref();
const canvas = ref();
const captures: any = ref([]);
const isCameraOpen = ref(false);
const listData = ref();
const page = ref(0);
const score = ref(0);
const answer = ref([] as Array<object>);
const answersList = ref<Array<{ questionId: any; choiceId: any[]; answerUser: any }>>([]);
import router from "@/router";
import { el } from "@fullcalendar/core/internal-common";
const submitButton = ref(false);
export default defineComponent({
  name: "blog-detail",
  components: {},
  data() {
    return {
      checkPermission: 0,
      timeInSecs: 0,
      ticker: 0,
      imageUrl: process.env.VUE_APP_IMG_URL,
      countdown: "",
      dataParams: this.$route.params,
      // eslint-disable-next-line no-undef
      localStream: {
        srcObject: "",
      },
      componentKey: 0,
      percentPass: 60,
      currentScore: 0,
      currentScoreUser: 0,
      currentPercent: 0,
      currentRound: 0,
      chapterName: "",
      limitTime: 0,
      calcDisplay: "0",
      calcExpression: "",
      calcHasResult: false,
    };
  },
  setup() {
    /* eslint-disable */
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      // if (localStorage.getItem("answer")) {
      //   answer.value = JSON.parse(localStorage.getItem("answer")!);
      // }
      answersList.value = [];
      // console.log(answer.value);
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      getDataList();
    });
    const getDataList = async () => {
      const getSyllabus = await axios.get(
        process.env.VUE_APP_API_URL + "/getSyllabus?id=" + route.params.sbId,
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      const getCourse = await axios.get(
        process.env.VUE_APP_API_URL + "/getCourse?id=" + route.params.cId,
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExamQuestion?examId=" +
            route.params.exId,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          listData.value = response.data.data;
          // console.log(getSyllabus.data.data.content);

          setCurrentPageBreadcrumbs(getCourse.data.data.content[0].title, [
            getSyllabus.data.data.content[0].name,
          ]);
        })
        .catch((error) => {
          // console.log(error);
        });
      if (isCameraOpen.value == false) {
        // console.log(video.value);
      }
    };
    // const register = () => {
    //   router.push({ name: "mandatory-learn", params: { id: route.params.id } });
    // };
    const previousPage = () => {
      page.value = page.value - 1;
    };
    const nextPage = () => {
      page.value = page.value + 1;
    };
    const changePage = (event) => {
      page.value = event;
    };
    const setDataInArrayObjectById = (array, id, answer, type) => {
      const foundObject = array.find((obj) => obj.questionId === id);
      if (!foundObject) {
        return false;
      }
      return true;
    };
    const setAnswer = (qId, dataAnswer, type, page) => {
      const list: any = {};
      if (answersList.value.length > 0) {
        // console.log(answersList.value);
        if (
          setDataInArrayObjectById(answersList.value, qId, dataAnswer, type) ==
          false
        ) {
          if (type == 1) {
            answer.value[page] = dataAnswer;
            list.questionId = qId;
            list.choiceId = [dataAnswer];
            list.answerUser = "";
          } else {
            list.questionId = qId;
            list.choiceId = [];
            list.answerUser = dataAnswer;
          }
        } else {
          for (const loopAnswer of answersList.value) {
            let data: any = [];
            data.push(dataAnswer);
            // console.log(dataAnswer);
            if (loopAnswer.questionId == qId) {
              if (type == 1) {
                answer.value[page] = dataAnswer;
                loopAnswer.choiceId = data;
                loopAnswer.answerUser = "";
              } else {
                loopAnswer.choiceId = [];
                loopAnswer.answerUser = dataAnswer;
              }
            }
          }
        }
      } else {
        if (type == 1) {
          answer.value[page] = dataAnswer;
          list.questionId = qId;
          list.choiceId = [dataAnswer];
          list.answerUser = "";
        } else {
          list.questionId = qId;
          list.choiceId = [];
          list.answerUser = dataAnswer;
        }
      }
      if (list.questionId) {
        answersList.value.push(list);
      }

      // localStorage.setItem("qId" + qId, qaId);
    };
    return {
      getDataList,
      listData,
      // register,
      page,
      previousPage,
      nextPage,
      answer,
      changePage,
      setAnswer,
      video,
      canvas,
      captures,
      isCameraOpen,
      route,
      answersList,
      setDataInArrayObjectById,
      dialogVisible,
      customColorMethod,
      submitButton,
    };
  },
  async mounted() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.componentKey += 1;
      page.value = 0;
    }
    let exam = await axios.get(
      process.env.VUE_APP_API_URL + "/getExam?id=" + this.$route.params.exId,
      {
        headers: {
          token: localStorage.getItem("id_token"),
        },
      },
    );
    // this.createCameraElement();
    this.percentPass = exam.data.data.content[0].percentPass;
    let courseSection = await axios.get(
      process.env.VUE_APP_API_URL +
        "/getCourseSection?id=" +
        this.$route.params.secId,
      {
        headers: {
          token: localStorage.getItem("id_token"),
        },
      },
    );
    for (const loopChapter of courseSection.data.data.content[0].chapters) {
      if (loopChapter.chapterId == this.$route.params.chId) {
        this.chapterName = loopChapter.titleChapter;
        if (loopChapter.flgSuccess === true) {
          await Swal.fire({
            icon: "info",
            title: "ผ่านแบบทดสอบแล้ว",
            text: "คุณผ่านแบบทดสอบบทนี้แล้ว",
            confirmButtonText: "ตกลง",
          });
          router.push({ name: "mandatory-learn", params: { sbId: this.$route.params.sbId, cId: this.$route.params.cId } });
          return;
        }
      }
    }
    this.limitTime = exam.data.data.content[0].limitTime;
    if (listData.value && listData.value.length > 0) {
      this.startTimer(this.limitTime * 60);
    }else {
     this.countdown = "-- : --";
    }
    // this.startTimer(exam.data.data.content[0].limitTime * 60);
  },
  methods: {
    calcClear() {
      this.calcDisplay = "0";
      this.calcExpression = "";
      this.calcHasResult = false;
    },
    calcInput(val: string) {
      const ops = ["+", "-", "*", "/"];
      if (val === "⌫") {
        if (this.calcHasResult) {
          this.calcDisplay = "0";
          this.calcExpression = "";
          this.calcHasResult = false;
          return;
        }
        this.calcDisplay = this.calcDisplay.length > 1 ? this.calcDisplay.slice(0, -1) : "0";
        return;
      }
      if (ops.includes(val)) {
        this.calcExpression = (this.calcHasResult ? this.calcDisplay : this.calcExpression + this.calcDisplay) + val;
        this.calcDisplay = "0";
        this.calcHasResult = false;
        return;
      }
      if (this.calcHasResult) {
        this.calcDisplay = val === "." ? "0." : val;
        this.calcExpression = "";
        this.calcHasResult = false;
        return;
      }
      if (val === "." && this.calcDisplay.includes(".")) return;
      this.calcDisplay = this.calcDisplay === "0" && val !== "." ? val : this.calcDisplay + val;
    },
    calcEqual() {
      try {
        const expr = this.calcExpression + this.calcDisplay;
        // eslint-disable-next-line no-eval
        const result = Function('"use strict"; return (' + expr + ')')();
        this.calcDisplay = String(parseFloat(result.toFixed(10)));
        this.calcExpression = expr + "=";
        this.calcHasResult = true;
      } catch {
        this.calcDisplay = "Error";
        this.calcExpression = "";
        this.calcHasResult = true;
      }
    },
    todo() {
      isCameraOpen.value = true;
      this.createCameraElement();
      window.setInterval(() => {
        this.capture();
      }, 2000); // interval set to one sec.
    },
    checkCamera() {
      this.checkPermission = window.setInterval(() => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then((stream) => {
              // console.log(stream);
            })
            .catch((error) => {
              clearInterval(this.checkPermission);
              // console.log(error);
              Swal.fire({
                title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#323563",
                cancelButtonColor: "#d33",
                confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
                allowOutsideClick: false,
                cancelButtonText: "กลับสู่หน้าหลัก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.createCameraElement();
                } else {
                  router.push({ name: "mandatory-learn" });
                }
              });
            });
        }
      }, 2000);
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    toggleCamera() {
      if (isCameraOpen.value) {
        isCameraOpen.value = false;
        this.stopCameraStream();
      } else {
        isCameraOpen.value = true;
        this.createCameraElement();
      }
      //  createCameraElement();
      //  stopCameraStream();
    },
    createCameraElement() {
      isCameraOpen.value = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: false })
          .then((stream) => {
            video.value.srcObject = stream;
            video.value.play();
            this.startTimer(5 * 60);
            this.checkCamera();
          })
          .catch((error) => {
            // console.log(error);
            Swal.fire({
              title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#323563",
              cancelButtonColor: "#d33",
              confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
              allowOutsideClick: false,
              cancelButtonText: "กลับสู่หน้าหลัก",
            }).then((result) => {
              if (result.isConfirmed) {
                this.createCameraElement();
              } else {
                router.push({ name: "mandatory-learn" });
              }
            });
          });
      }
    },
    stopCameraStream() {
      video.value = video.value.srcObject.getTracks();
      video.value.forEach((track) => {
        track.stop();
      });
    },
    capture() {
      /* eslint-disable */
      canvas.value = this.$refs.canvas;
      var context: any = canvas.value
        .getContext("2d")
        .drawImage(this.video, 0, 0, 640, 480);
      // console.log(canvas.value.toDataURL("image/png"));
      captures.value.push(canvas.value.toDataURL("image/png"));
      // this.captures.push(canvas.value.toDataURL("image/png"));
      /* eslint-disable */
    },
    startTimer(secs) {
      this.timeInSecs = parseInt(secs);
      this.ticker = window.setInterval(() => {
        this.tick();
      }, 1000);
    },
    tick() {
      var secs = this.timeInSecs;
      if (secs > 0) {
        this.timeInSecs--;
      } else {
        clearInterval(this.ticker);
        Swal.fire({
          title: "หมดเวลาทำข้อสอบแล้ว!",
          text: "ต้องการส่งคำตอบหรือไม่ ?",
          icon: "error",
          buttonsStyling: false,
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonText: "ส่งคำตอบ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn fw-semibold btn-primary btn-lg",
            cancelButton: "btn fw-semibold btn-light-danger btn-sm",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.submit();
          } else {
            this.$router.go(-1);
          }
        });
      }
      var mins = Math.floor(secs / 60);
      secs %= 60;
      var pretty =
        (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
      this.countdown = pretty;
      localStorage.setItem("timer", secs + "");
    },
    percentageToDegrees(percentage) {
      return (percentage / 100) * 360;
    },
    convertStoMs(limit, countdown) {
      if (!countdown || !countdown.includes(":") || !limit) return "00 : 00";
      const parts = countdown.split(":");
      const remainSecs = parseInt(parts[0]) * 60 + parseInt(parts[1]);
      const usedSecs = parseInt(limit) * 60 - remainSecs;
      if (isNaN(usedSecs) || usedSecs < 0) return "00 : 00";
      let minutes: any = Math.floor(usedSecs / 60);
      let extraSeconds: any = usedSecs % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
      return minutes + " : " + extraSeconds;
    },
    async submit() {
      submitButton.value = true;
      Swal.fire({
        title: "ต้องการส่งคำตอบใช่หรือไม่",
        icon: "warning",
        buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: "ส่งคำตอบ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn fw-semibold btn-primary btn-lg",
            cancelButton: "btn fw-semibold btn-light-danger btn-sm",
          },
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "กำลังดำเนินการ...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          clearInterval(this.ticker);
          clearInterval(this.checkPermission);
          let timeSubmit = this.convertStoMs(this.limitTime, this.countdown);
          let examId = this.$route.params.exId;
          let courseRegisterId = await this.getCourseRegister(
            this.$route.params.cId,
          );
          // console.log(courseRegisterId);
          score.value = 0;
          axios
            .post(
              process.env.VUE_APP_API_URL + "/checkAnswer",
              answersList.value,
              {
                headers: {
                  token: localStorage.getItem("id_token"),
                },
              },
            )
            .then((res) => {
              score.value = res.data.data.score;
              const formData = new FormData();
              formData.append("score", score.value + "");
              formData.append("examId", examId + "");
              formData.append("courseRegisterId", courseRegisterId + "");
              formData.append("timeSubmit", timeSubmit + "");
              formData.append(
                "flgPretest",
                this.$route.params.type == "pretest" ? "true" : "false",
              );
              axios
                .post(process.env.VUE_APP_API_URL + "/updateScore", formData, {
                  headers: {
                    token: localStorage.getItem("id_token"),
                  },
                })
                .then(async (res) => {
                  if (res.data.code == 200) {
                    Swal.close();
                    let percent = await this.formatNumber(
                      (score.value / listData.value.length) * 100,
                    );
                    this.currentScore = listData.value.length;
                    this.currentScoreUser = score.value;
                    this.currentPercent = percent;
                    this.currentRound = res.data.data.round;
                    if (percent >= this.percentPass) {
                    dialogVisible.value = true;
                    answer.value = [];
                    await this.updateProgress();
                  } else {
                    dialogVisible.value = true;
                    answer.value = [];
                    // console.log(this.$route.params.type);
                    if (this.$route.params.type == "pretest") {
                      await this.updateProgress();
                    }
                  }
                  } else {
                    Swal.fire({
                      title: "แจ้งเตือนข้อผิดพลาด",
                      text: res.data.message,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                      customClass: {
                        confirmButton: "btn fw-semobold btn-light-danger",
                      },
                    });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    title: "แจ้งเตือนข้อผิดพลาด",
                    text: error.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                    customClass: {
                      confirmButton: "btn fw-semobold btn-light-danger",
                    },
                  });
                });
            })
            .catch((error) => {
              // console.log(error);
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }else{
          submitButton.value = false
        }
      });
    },
    async getCourseRegister(courseId) {
      let courseRegisterId = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          courseId +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      // console.log(courseRegisterId.data.data);
      return courseRegisterId.data.data.content[0].id;
    },
    async updateProgress() {
      const formData = new FormData();
      formData.append("courseId", this.$route.params.cId + "");
      formData.append("sectionId", this.$route.params.secId + "");
      formData.append("chapterId", this.$route.params.chId + "");
      // console.log("update");
      await axios
        .post(process.env.VUE_APP_API_URL + "/updateProgress", formData, {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        })
        .then((res) => {
          setTimeout(() => {
            router.go(-1);
          }, 1000);
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    formatNumber(score) {
      return parseInt(score);
    },
    forceRerender() {
      this.componentKey += 1;
    },
    onBack() {
      submitButton.value = false;
      dialogVisible.value = false;
      router.go(-1);
    },
  },

  beforeUnmount() {
    localStorage.setItem("reloaded", "1");
    clearInterval(this.ticker);
  },
});
